const mutations = {
  setInvoiceData (state, invoiceData) {
    state.invoiceData = invoiceData
  }
}
export default mutations
